/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for TaxResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetTaxByIdResponse, GetTaxSelectResponse, GetTaxesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TaxResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTaxById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetTaxByIdResponse, unknown> & { defaultValue: NoInfer<GetTaxByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxByIdResponse>;
    getTaxById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTaxByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxByIdResponse | undefined>;
    getTaxById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTaxByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Taxe/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTaxSelect(resourceOptions: HttpResourceOptions<GetTaxSelectResponse, unknown> & { defaultValue: NoInfer<GetTaxSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxSelectResponse>;
    getTaxSelect(resourceOptions?: HttpResourceOptions<GetTaxSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxSelectResponse | undefined>;
    getTaxSelect(resourceOptions?: HttpResourceOptions<GetTaxSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Taxe/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTaxes(searchTerm: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetTaxesResponse, unknown> & { defaultValue: NoInfer<GetTaxesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxesResponse>;
    getTaxes(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetTaxesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxesResponse | undefined>;
    getTaxes(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetTaxesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTaxesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            return {
                url: `${this.basePath}/Taxe`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
